

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Lockr from 'lockr';
import VideoFile from '@/lib/VideoFile';
import { wlPath } from '@/lib/Whitelabel';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

const DEFAULT_VIDEO_VOLUME = 0.6;
const DEFAULT_VIDEO_IS_MUTED = true;

@Component
export default class VideoPlayer extends Vue {

  // reactive properties
  currentVideoIndex = -1;
  videoTitle = '';

  // injected properties
  //@Prop({ required: true }) playerId!: string;
  @Prop({ required: true }) videoList!: VideoFile[];

  // non-reactive properties
  private player: videojs.Player | undefined;

  // watches
  // @Watch('playerId', {
  //   immediate: true,
  // })
  // onChangedPlayerId(newPlayerId: string) {
  //   if ( newPlayerId ) {
  //     this._playerId = newPlayerId;
  //   }
  // }

  // lifecycle
  mounted() {
    console.log("mounting video player");
    this.player = videojs(this.$refs.mainPlayer, {
      autoplay: false,
      controlBar: {
        children: [
          "playToggle",
          "volumeMenuButton",
          "durationDisplay",
          "timeDivider",
          "currentTimeDisplay",
          "progressControl",
          "remainingTimeDisplay"
        ],
        // fullscreenToggle: false,
        // pictureInPictureToggle: false,
        // subsCapsButton: false,
        volumePanel: {
          inline: true,
          volumeControl: {
            vertical: false,
          },
        },
      },
      controls: true,
      html5: { nativeTextTracks: false },
      inactivityTimeout: 0,
      loop: false,
      preload: 'auto',
    });

    this.player.on('ended', () => {
      //console.log('video just ended');
      Vue.nextTick(() => {
        this.playNextVideo();
      });
    });

    this.player.on('volumechange', () => {
      if ( this.player ) {
        const volume = this.player.volume();
        const isMuted = this.player.muted();
        //console.log(`volume=${volume} muted=${isMuted}`);
        Lockr.set('kb_videoVolume', volume);
        Lockr.set('kb_videoIsMuted', isMuted);
      }
    });

    // The initial player doesn't have a video src to start with. So we can't expect a
    // ready event. Calling this function will assign a video source and wait for the
    // ready event to start the video.
    this.playNextVideo();

    this.$root.$on('idle-on-homepage', () => {
      if ( this.player ) {
        if ( this.player.paused() ) {
          window.location.replace('/'); // hard restart -- sometimes player dies
          // console.log('restarting video player');
          // this.player.play();
          // this.player.muted = true;
        }
        // if ( this.player.playing && !this.player.muted ) {
        //   this.player.muted = true;
        // }
      }
    });

  }

  beforeDestroy() {
    if ( this.player ) {
      console.log("disposing video player");
      this.player.dispose();
      this.player = undefined;
    }
  }

  // computed
  get videos(): VideoFile[] {
    return this.videoList ? this.videoList : [];
  }

  // methods
  playNextVideo() {
    this.currentVideoIndex = (this.currentVideoIndex + 1) % this.videos.length;
    const videoFile = this.videos[this.currentVideoIndex];
    console.log(`play next video: [${this.currentVideoIndex}] ${videoFile.title}`);
    if ( this.player ) {
      this.videoTitle = videoFile.title;
      this.player.src(this.createSourceInfo(wlPath, videoFile));
      console.log(`  \`--> assigning a new video source`);
      if ( videoFile.vtt ) {
        this.player.addRemoteTextTrack(this.createCaptionInfo(wlPath, videoFile), false);
        console.log(`  \`--> assigning a new captions source`);
      }
      // when changing the source, need to wait until player says it can play
      this.player.ready(async () => {
        console.log(`  \`--> video is ready to play`);
        await this.playReadiedVideo();
      });
    }
    else {
      console.log(`  \`--> whoops, no player object`);
      this.puntOnVideoPlayFailure();
    }
  }

  async playReadiedVideo() {
    const videoVolume =  Lockr.get('kb_videoVolume', DEFAULT_VIDEO_VOLUME);
    const videoIsMuted =  Lockr.get('kb_videoIsMuted', DEFAULT_VIDEO_IS_MUTED);
    try {
      if ( this.player ) {
        console.log(`    \`--> calling play()`);
        this.player.volume(videoVolume);
        this.player.muted(videoIsMuted);
        await this.player.play();
        console.log(`    \`--> called play()`);
      }
      else {
        console.log(`    \`--> no player object to play`);
        this.puntOnVideoPlayFailure();
      }
    }
    catch (err) {
      console.log(`    \`--> error when attempting to play video: `, err);
      this.puntOnVideoPlayFailure();
    }
  }

  puntOnVideoPlayFailure() {
    console.log(`  \`--> playing video failed -- restart`);
    setTimeout(() => {
      window.location.replace('/'); // hard restart -- sometimes player dies
      //console.log(">>>>>>>>>>>>>>>>> FAIL!!!!!!!!!!!!!!!!!!!");
    }, 250);
  }

  createSourceInfo(whitelabelPath: string, videoFile: VideoFile): videojs.Tech.SourceObject {
    return {
      src: `/video/${whitelabelPath}/${videoFile.mp4}`,
      type: 'video/mp4',
    };
  }

  createCaptionInfo(whitelabelPath: string, videoFile: VideoFile): videojs.TextTrackOptions {
    return {
      kind: 'captions',
      mode: 'showing',
      srclang: 'en',
      src: `/video/${whitelabelPath}/${videoFile.vtt}`,
    };
  }

}
